<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Solicitudes</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Hidrocarburos</li>
                  <li class="breadcrumb-item active">Procesos</li>
                  <li class="breadcrumb-item active">Solicitudes</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <!-- Header con botones de acción -->
            <div class="row">
              <div class="col-12">
                <div
                  class="card shadow-sm border-0"
                  :class="$store.getters.getDarkMode ? 'bg-dark' : 'bg-white'"
                >
                  <div
                    class="card-header border-0 py-3"
                    :class="
                      $store.getters.getDarkMode
                        ? 'bg-dark border-secondary'
                        : 'bg-light'
                    "
                  >
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <h5
                          class="mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-file-alt me-2 text-primary"></i>
                          Gestión de Solicitudes
                        </h5>
                        <p class="mb-0 text-muted small">
                          Administra las solicitudes de hidrocarburos
                        </p>
                      </div>
                      <div class="btn-group" role="group">
                        <button
                          type="button"
                          class="btn btn-outline-info"
                          @click="pivotTable()"
                          v-if="
                            $store.getters.can(
                              'hidrocarburos.solicitudes.pivotTable',
                            )
                          "
                          data-bs-toggle="tooltip"
                          title="Vista de tabla dinámica"
                        >
                          <i class="fas fa-scroll me-1"></i>
                          Tabla Dinámica
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-success"
                          data-toggle="modal"
                          data-target="#modal-form-solicitudes-export"
                          v-if="
                            $store.getters.can(
                              'hidrocarburos.reportes.solicitudExport',
                            )
                          "
                          data-bs-toggle="tooltip"
                          title="Exportar a Excel"
                        >
                          <i class="far fa-file-excel me-1"></i>
                          Exportar
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          v-if="
                            $store.getters.can(
                              'hidrocarburos.solicitudes.create',
                            )
                          "
                          @click="create()"
                          data-bs-toggle="tooltip"
                          title="Crear nueva solicitud"
                        >
                          <i class="fas fa-plus me-1"></i>
                          Nueva Solicitud
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-secondary"
                          @click="getIndex()"
                          data-bs-toggle="tooltip"
                          title="Actualizar datos"
                        >
                          <i class="fas fa-sync-alt me-1"></i>
                          Actualizar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sección de filtros -->
            <div class="row">
              <div class="col-12">
                <div
                  class="card"
                  :class="
                    $store.getters.getDarkMode
                      ? 'bg-dark border-secondary'
                      : 'bg-white'
                  "
                >
                  <div
                    class="card-header py-2"
                    :class="
                      $store.getters.getDarkMode
                        ? 'bg-dark border-secondary'
                        : 'bg-light'
                    "
                  >
                    <h6
                      class="mb-0"
                      :class="
                        $store.getters.getDarkMode ? 'text-light' : 'text-dark'
                      "
                    >
                      <i class="fas fa-filter me-2"></i>
                      Filtros de Búsqueda
                    </h6>
                  </div>
                  <div class="card-body py-3">
                    <div class="row">
                      <!-- Filtro ID -->
                      <div class="col-md-6 col-lg-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-hashtag me-1"></i>
                          ID
                        </label>
                        <input
                          type="number"
                          class="form-control form-control-sm"
                          v-model="filtros.id"
                          @keyup="getIndex()"
                          placeholder="Buscar ID..."
                        />
                      </div>

                      <!-- Filtro Nominación -->
                      <div class="col-md-6 col-lg-3">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-tag me-1"></i>
                          Nominación
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="nominacion"
                          label="nombre"
                          class="form-control form-control-sm p-0"
                          :options="
                            Array.isArray(listasForms.nominaciones)
                              ? listasForms.nominaciones
                              : []
                          "
                          :filterable="true"
                          @input="getIndex()"
                          placeholder="Seleccionar..."
                        ></v-select>
                      </div>

                      <!-- Filtro Sitio -->
                      <div class="col-md-6 col-lg-3">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-map-marker-alt me-1"></i>
                          Sitio
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="sitio"
                          label="nombre"
                          class="form-control form-control-sm p-0"
                          :options="
                            Array.isArray(listasForms.sitios)
                              ? listasForms.sitios
                              : []
                          "
                          :filterable="true"
                          @input="getSelectSitio()"
                          placeholder="Seleccionar..."
                        ></v-select>
                      </div>

                      <!-- Filtro Fecha -->
                      <div class="col-md-6 col-lg-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-calendar me-1"></i>
                          Fecha
                        </label>
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          v-model="filtros.fecha"
                          @change="getIndex()"
                        />
                      </div>

                      <!-- Filtro Estado -->
                      <div class="col-md-6 col-lg-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-toggle-on me-1"></i>
                          Estado
                        </label>
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.estado"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            :key="estado.id"
                            :value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Botón limpiar filtros -->
                    <div class="row mt-3">
                      <div class="col-12">
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm"
                          @click="limpiarFiltros()"
                        >
                          <i class="fas fa-eraser me-1"></i>
                          Limpiar Filtros
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Contenido principal - Solo Tabla -->
            <div
              class="card"
              :class="
                $store.getters.getDarkMode
                  ? 'bg-dark border-secondary'
                  : 'bg-white'
              "
            >
              <div
                class="card-header py-2"
                :class="
                  $store.getters.getDarkMode
                    ? 'bg-dark border-secondary'
                    : 'bg-light'
                "
              >
                <div class="d-flex justify-content-between align-items-center">
                  <h6
                    class="mb-0"
                    :class="
                      $store.getters.getDarkMode ? 'text-light' : 'text-dark'
                    "
                  >
                    <i class="fas fa-table me-2"></i>
                    Lista de Solicitudes
                  </h6>
                  <span class="badge bg-primary">
                    {{ solicitudes.total || 0 }} registros
                  </span>
                </div>
              </div>

              <div class="card-body p-0">
                <div class="table-responsive">
                  <table
                    class="table table-hover table-striped mb-0"
                    :class="$store.getters.getDarkMode ? 'table-dark' : ''"
                  >
                    <thead
                      :class="
                        $store.getters.getDarkMode
                          ? 'table-dark'
                          : 'table-light'
                      "
                    >
                      <tr>
                        <th class="text-center" style="width: 80px;">
                          <i class="fas fa-hashtag me-1"></i>
                          #
                        </th>
                        <th>
                          <i class="fas fa-tag me-1"></i>
                          Nominación
                        </th>
                        <th>
                          <i class="fas fa-map-marker-alt me-1"></i>
                          Sitio
                        </th>
                        <th>
                          <i class="fas fa-calendar me-1"></i>
                          Fecha
                        </th>
                        <th class="text-center">
                          <i class="fas fa-toggle-on me-1"></i>
                          Estado
                        </th>
                        <th class="text-center" style="width: 120px;">
                          <i class="fas fa-cogs me-1"></i>
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="solicitud in solicitudes.data"
                        :key="solicitud.id"
                      >
                        <td class="text-center">
                          <span class="badge bg-secondary">{{
                            solicitud.id
                          }}</span>
                        </td>
                        <td>
                          <span
                            v-if="solicitud.nominacion != null"
                            class="badge bg-info"
                          >
                            {{ solicitud.nominacion.nombre }}
                          </span>
                          <span v-else class="text-muted small"
                            >Sin nominación</span
                          >
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ solicitud.sitio.nombre }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ solicitud.fecha }}
                          </span>
                        </td>
                        <td class="text-center">
                          <span
                            class="badge"
                            :class="
                              solicitud.estado == 1
                                ? 'bg-warning'
                                : 'bg-success'
                            "
                          >
                            {{ solicitud.nEstado }}
                          </span>
                        </td>
                        <td class="text-center">
                          <div class="btn-group btn-group-sm" role="group">
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              v-if="
                                $store.getters.can(
                                  'hidrocarburos.solicitudes.show',
                                )
                              "
                              @click="edit(solicitud)"
                              title="Ver/Editar solicitud"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-danger"
                              v-if="
                                $store.getters.can(
                                  'hidrocarburos.solicitudes.delete',
                                ) && solicitud.estado != 2
                              "
                              @click="destroy(solicitud.id)"
                              title="Eliminar solicitud"
                            >
                              <i class="fas fa-trash-alt"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Mensaje cuando no hay datos -->
                <div
                  v-if="!solicitudes.data || solicitudes.data.length === 0"
                  class="text-center py-5"
                >
                  <i
                    class="fas fa-file-alt text-muted mb-3"
                    style="font-size: 3rem;"
                  ></i>
                  <h5 class="text-muted">No hay solicitudes para mostrar</h5>
                  <p class="text-muted">
                    Utiliza los filtros para buscar solicitudes específicas
                  </p>
                </div>
              </div>
              <div
                class="card-footer border-0"
                :class="
                  $store.getters.getDarkMode
                    ? 'bg-dark border-secondary'
                    : 'bg-light'
                "
              >
                <div class="d-flex justify-content-between align-items-center">
                  <div v-if="solicitudes.total">
                    <p class="mb-0 small text-muted">
                      Mostrando del
                      <span class="fw-bold text-primary">{{
                        solicitudes.from
                      }}</span>
                      al
                      <span class="fw-bold text-primary">{{
                        solicitudes.to
                      }}</span>
                      de un total:
                      <span class="fw-bold text-primary">{{
                        solicitudes.total
                      }}</span>
                      registros
                    </p>
                  </div>
                  <div v-else>
                    <span class="badge bg-danger">
                      No hay registros para mostrar
                    </span>
                  </div>
                  <pagination
                    :data="solicitudes"
                    @pagination-change-page="getIndex"
                    :limit="5"
                    align="right"
                  >
                  </pagination>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <SolicitudExport ref="SolicitudExport" />
  </div>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import Loading from "../../../../components/Loading";
import SolicitudExport from "./SolicitudExport";
import vSelect from "vue-select";
export default {
  name: "Solicitudes",
  components: {
    pagination,
    Loading,
    vSelect,
    SolicitudExport,
  },
  data() {
    return {
      storageKeyFiltros: "hidrocarburos_solicitud_filtros",
      cargando: false,
      filtros: {
        id: null,
        estado: null,
        fecha: null,
        nominacion_id: null,
        sitio: null,
      },
      sitio: null,
      nominacion: null,
      solicitudes: {},
      listasForms: {
        estados: [],
        sitios: [],
        nominaciones: [],
      },
    };
  },
  methods: {
    getStoredFiltros() {
      try {
        const raw = sessionStorage.getItem(this.storageKeyFiltros);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    },
    setStoredFiltros() {
      try {
        const payload = {
          filtros: {
            id: this.filtros.id,
            estado: this.filtros.estado,
            fecha: this.filtros.fecha,
            nominacion_id: this.filtros.nominacion_id,
            sitio: this.filtros.sitio,
          },
          nominacion:
            this.nominacion && this.nominacion.id
              ? { id: this.nominacion.id, nombre: this.nominacion.nombre || "" }
              : null,
          sitio:
            this.sitio && this.sitio.id
              ? { id: this.sitio.id, nombre: this.sitio.nombre || "" }
              : null,
        };
        sessionStorage.setItem(this.storageKeyFiltros, JSON.stringify(payload));
      } catch (e) {
        // sessionStorage no disponible
      }
    },
    clearStoredFiltros() {
      try {
        sessionStorage.removeItem(this.storageKeyFiltros);
      } catch (e) {
        // sessionStorage no disponible
      }
    },
    getIndex(page = 1) {
      this.cargando = true;
      const stored = this.getStoredFiltros();
      if (stored) {
        const f = stored.filtros;
        this.filtros.id = f.id ?? null;
        this.filtros.estado = f.estado ?? null;
        this.filtros.fecha = f.fecha || null;
        this.filtros.nominacion_id = f.nominacion_id ?? null;
        this.filtros.sitio = f.sitio ?? null;
        this.nominacion = stored.nominacion || null;
        this.sitio = stored.sitio || null;
        this.clearStoredFiltros();
      } else {
        if (this.nominacion != null) {
          this.filtros.nominacion_id = this.nominacion.id;
        } else {
          this.filtros.nominacion_id = null;
        }
      }
      axios
        .get("/api/hidrocarburos/solicitudes?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.solicitudes = response.data;
          this.cargando = false;
        });
    },

    getEstados() {
      this.cargando = true;
      axios.get("/api/lista/28").then((response) => {
        this.listasForms.estados = response.data;
        this.cargando = false;
      });
    },

    getNominaciones() {
      this.cargando = true;
      axios
        .get("/api/hidrocarburos/nominacion/list")
        .then((response) => {
          this.listasForms.nominaciones = Array.isArray(response.data)
            ? response.data
            : [];
          this.cargando = false;
        })
        .catch(() => {
          this.listasForms.nominaciones = [];
          this.cargando = false;
        });
    },

    getSitios() {
      this.cargando = true;
      axios
        .get("/api/admin/sitios/lista")
        .then((response) => {
          this.listasForms.sitios = Array.isArray(response.data)
            ? response.data
            : [];
          this.cargando = false;
        })
        .catch(() => {
          this.listasForms.sitios = [];
          this.cargando = false;
        });
    },

    getSelectSitio() {
      this.filtros.sitio = this.sitio && this.sitio.id ? this.sitio.id : null;
      this.getIndex();
    },

    destroy(idSolicitud) {
      this.$swal({
        title: "Esta seguro de eliminar esta Solicitud?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        // <--
        if (result.value) {
          axios
            .delete("/api/hidrocarburos/solicitudes/" + idSolicitud)
            .then(() => {
              this.getIndex();
              this.$swal({
                icon: "success",
                title: "Se elimino la Solicitud exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
              });
            });
        }
      });
    },

    create() {
      return this.$router.push({
        name: "/Hidrocarburos/SolicitudesFormCreate",
        params: { accion: "Crear", id: null },
      });
    },

    edit(solicitud) {
      this.setStoredFiltros();
      return this.$router.push({
        name: "/Hidrocarburos/SolicitudesFormEdit",
        params: { accion: "Editar", data_edit: solicitud, id: solicitud.id },
      });
    },
    pivotTable() {
      return this.$router.push({
        name: "/Hidrocarburos/SolicitudesPivotTable",
      });
    },

    limpiarFiltros() {
      this.filtros = {
        id: null,
        estado: null,
        fecha: null,
        nominacion_id: null,
        sitio: null,
      };
      this.sitio = null;
      this.nominacion = null;
      this.solicitudes = {};
      this.clearStoredFiltros();
      this.getIndex();
    },

    guardarFiltrosEnSession() {
      this.setStoredFiltros();
    },
  },
  watch: {
    $route(to) {
      if (to.path !== "/Hidrocarburos/Solicitudes") return;
      if (!this.getStoredFiltros()) return;
      this.getIndex(1);
    },
  },
  mounted() {
    this.getEstados();
    this.getNominaciones();
    this.getSitios();
    this.getIndex();
  },
};
</script>
